import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormHelperText,
  FormControlLabel,
  Checkbox,
  Grid,
} from '@material-ui/core';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import { resolveSagisClaim } from 'helpers/utils';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {
  DATE_FORMAT,
  DATE_PICKET_FORMAT,
  DOCUMENT_TYPES,
} from 'constants/global';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import moment from 'moment-timezone';
import {
  EMPTY_JUDGEMENT_INFO,
  EMPTY_JUDGEMENT_ON_MERITS_DOC,
  JUDGEMENT_INFO_FIELDS,
} from 'containers/data-structure';
import { IJudgementOnMeritsInfo } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import {
  IUploadedDocument,
  JudgementOnMeritsType,
} from 'containers/LawyerLegalProceedingsPage/typings';
import { get, isEmpty } from 'lodash';
import { LABEL_WIDTH } from 'containers/PreOpeningPage/OpposingParty/constants';
import {
  CORRECTIONAL_DOC_ID,
  JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
  JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { handleOpenDocument } from 'services/utils';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  EMPTY_SUPPORT_DOC,
  SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID,
} from 'containers/LawyerRecapPage/constants';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import {
  STATUS_PENDING,
  STATUS_VALIDATED,
} from 'containers/LawyerFeeNote/constants';

export interface AdditionalInfoJudgementOnMeritsProps {
  intl: IntlShape;
  judgementOnMeritsInfo: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  handleJudgementOnMeritsDocChange: Function;
  documentId: string | undefined;
  setDocumentId: Function;
  resetUploadedDocument: Function;
  setJudgementOnMeritsInfo: Function;
  judgementOnMerits: JudgementOnMeritsType;
  isManager: boolean;
  requestAddJudgementOnMeritsSupportDocument: Function;
  claimId?: number;
  claimNumber?: string;
  isAssignedLawyer: boolean;
  isCreator: boolean;
  imagineDocuments: any;
  policyInfo: any;
  listings: any;
  requestGetDocByDocumentumId: Function;
}
const AdditionalInfoJudgementOnMerits: React.FC<AdditionalInfoJudgementOnMeritsProps> = ({
  resetUploadedDocument,
  uploadDocument,
  handleJudgementOnMeritsDocChange,
  documentId,
  uploadedDocument,
  setDocumentId,
  judgementOnMeritsInfo,
  judgementOnMerits,
  setJudgementOnMeritsInfo,
  claimId,
  claimNumber,
  ...props
}): JSX.Element => {
  const [judgementInfo, setJudgementInfo] = useState<IJudgementOnMeritsInfo>(
    EMPTY_JUDGEMENT_INFO,
  );

  const [JudgementOnMeritsDoc, setJudgementOnMeritsDoc] = useState<
    JudgementOnMeritsDoc
  >({
    ...EMPTY_JUDGEMENT_ON_MERITS_DOC,
  });

  const [depens, setDepens] = useState<unknown>(null);
  const [idd, setIdd] = useState<unknown>(null);

  const [defenseToExecution, setDefenseToExecution] = useState<boolean>(false);
  const [difficultyToExecution, setDifficultyToExecution] = useState<boolean>(
    false,
  );

  const handleCheckBoxChangeDefenseToExecution = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { checked } = e.target;
    setDefenseToExecution(checked);
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]: checked,
    });
    setJudgementOnMeritsInfo({
      ...judgementOnMeritsInfo,
      [JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]: checked,
    });
  };

  const handleCheckBoxChangeDifficultyToExecution = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { checked } = e.target;
    setDifficultyToExecution(checked);
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION]: checked,
    });
    setJudgementOnMeritsInfo({
      ...judgementOnMeritsInfo,
      [JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION]: checked,
    });
  };

  const [isInputChanged, setIsInputChanged] = useState<boolean>(true);
  const requiredFieldMessage = translate(messages.validateRequiredField, props);

  const handleChange = (e: ChangeEvent<{ value: string }>) => {
    const { value } = e.target;
    setIsInputChanged(false);
    setJudgementInfo({ ...judgementInfo, [JUDGEMENT_INFO_FIELDS.COST]: value });
    setJudgementOnMeritsInfo({
      ...judgementOnMeritsInfo,
      [JUDGEMENT_INFO_FIELDS.COST]: value,
      [JUDGEMENT_INFO_FIELDS.DEPENS]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
    });
  };

  const handleCommentaryChange = (e: ChangeEvent<{ value: string }>) => {
    const { value } = e.target;
    setIsInputChanged(false);
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.COMMENTARY]: value,
    });
    setJudgementOnMeritsInfo({
      ...judgementOnMeritsInfo,
      [JUDGEMENT_INFO_FIELDS.COMMENTARY]: value,
    });
  };

  useEffect(() => {
    setJudgementOnMeritsInfo({
      ...judgementOnMeritsInfo,
      [JUDGEMENT_INFO_FIELDS.DEPENS]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
      [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    setIsInputChanged(false);
    const judgementDate = moment(theDate as Date).format(DATE_FORMAT);
    setJudgementInfo({
      ...judgementInfo,
      [JUDGEMENT_INFO_FIELDS.DATE]: judgementDate,
    });
    setJudgementOnMeritsInfo({
      ...judgementOnMeritsInfo,
      [JUDGEMENT_INFO_FIELDS.DATE]: judgementDate,
      [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
    });
  };

  const handleDepensChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setIsInputChanged(false);
    setDepens(event.target.value);
  };

  const handleIddChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setIsInputChanged(false);
    setIdd(event.target.value);
    if (event.target.value) {
      setJudgementOnMeritsInfo({
        ...judgementOnMeritsInfo,
        [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_SELECTED,
      });
    } else {
      setJudgementOnMeritsInfo({
        ...judgementOnMeritsInfo,
        [JUDGEMENT_INFO_FIELDS.IDD]: JUDGEMENT_ON_MERITS_ADDITIONAL_INFO_NOT_SELECTED,
        [JUDGEMENT_INFO_FIELDS.DATE]: null,
      });
    }
  };

  const setDocument = (document: CorporealDocument) => {
    if (CORRECTIONAL_DOC_ID === documentId) {
      setJudgementOnMeritsDoc(document);
      handleJudgementOnMeritsDocChange(document);
      !props.isManager && resetUploadedDocument();
    }
  };

  const judgementOnMeritsSupportDocuments = get(
    judgementOnMerits,
    'judgementOnMerits.jom.supportDocuments',
    [],
  ).filter(
    (el: any) => el.type === DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS,
  );

  const [supportDocument, setSupportDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });

  const setJudgementOnMeritsSupportDocument = (document: CorporealDocument) => {
    if (SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID === documentId) {
      setSupportDocument(document);
      props.requestAddJudgementOnMeritsSupportDocument &&
        props.requestAddJudgementOnMeritsSupportDocument({
          ...document,
          judgementOnMeritsId: get(
            judgementOnMerits,
            'judgementOnMerits.jom.id',
          ),
          status: get(currentIntervenantStorage?.get(), 'sagis_code')
            ? STATUS_PENDING
            : STATUS_VALIDATED,
          claimId,
          claimNumber,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          isLawyer: get(currentIntervenantStorage?.get(), 'sagis_code')
            ? true
            : false,
        });
      resetUploadedDocument();
    }
  };

  return (
    <>
      {isEmpty(judgementOnMerits) ? (
        <>
          <div className="correctional-judgement">
            <FormControl
              className="formEl"
              error={(depens === null || depens === '') && !isInputChanged}
            >
              <InputLabel id="depens-label-id">
                {translate(messages.judgementOnMeritsDepensFieldTitle, props)}
              </InputLabel>
              <Select
                labelId="depens-label-id"
                onChange={handleDepensChange}
                value={depens}
                labelWidth={LABEL_WIDTH}
              >
                <MenuItem key={0} value={1}>
                  {translate(messages.yes, props)}
                </MenuItem>
                <MenuItem key={1} value={0}>
                  {translate(messages.no, props)}
                </MenuItem>
              </Select>
              {(depens === null || depens === '') && !isInputChanged && (
                <FormHelperText className="errorSelect">
                  {requiredFieldMessage}
                </FormHelperText>
              )}
            </FormControl>

            {!!depens && (
              <div className="judgement-on-merits-info">
                <TextField
                  id="cost"
                  name={JUDGEMENT_INFO_FIELDS.COST}
                  label={translate(
                    messages.judgementOnMeritsCostFieldTitle,
                    props,
                  )}
                  onChange={handleChange}
                  value={judgementInfo[JUDGEMENT_INFO_FIELDS.COST]}
                  error={judgementInfo.cost === '' && !isInputChanged}
                  helperText={
                    judgementInfo.cost === '' && !isInputChanged
                      ? requiredFieldMessage
                      : ''
                  }
                />
              </div>
            )}
            <FormControl
              error={(idd === null || idd === '') && !isInputChanged}
            >
              <InputLabel id="idd-label-id">
                {translate(messages.judgementOnMeritsIddFieldTitle, props)}
              </InputLabel>
              <Select
                labelId="idd-label-id"
                onChange={handleIddChange}
                value={idd}
                labelWidth={LABEL_WIDTH}
              >
                <MenuItem key={0} value={1}>
                  {translate(messages.yes, props)}
                </MenuItem>
                <MenuItem key={1} value={0}>
                  {translate(messages.no, props)}
                </MenuItem>
              </Select>
              {(idd === null || idd === '') && !isInputChanged && (
                <FormHelperText className="errorSelect">
                  {requiredFieldMessage}
                </FormHelperText>
              )}
            </FormControl>

            {!!idd && (
              <div className="judgement-on-merits-info">
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    format={DATE_PICKET_FORMAT}
                    id="judgement-info-date"
                    onChange={handleChangeDate}
                    value={dateStringToLocalDate(
                      judgementInfo[JUDGEMENT_INFO_FIELDS.DATE],
                    )}
                    label={translate(messages.judgementInfoDate, props)}
                    error={
                      (judgementInfo.calculationStartDate === '' ||
                        judgementInfo.calculationStartDate === null ||
                        judgementInfo.calculationStartDate ===
                          'Invalid date') &&
                      !isInputChanged
                    }
                    helperText={
                      (judgementInfo.calculationStartDate === '' ||
                        judgementInfo.calculationStartDate === null) &&
                      !isInputChanged
                        ? requiredFieldMessage
                        : judgementInfo.calculationStartDate ===
                            'Invalid date' && !isInputChanged
                        ? translate(messages.invalidDate, props)
                        : ''
                    }
                  />
                </MuiPickersUtilsProvider>
              </div>
            )}
            <div className="judgement-on-merits-info">
              <TextField
                id="commentary"
                name={JUDGEMENT_INFO_FIELDS.COMMENTARY}
                label={translate(
                  messages.judgementOnMeritsCommentaryFieldTitle,
                  props,
                )}
                onChange={handleCommentaryChange}
                value={judgementInfo[JUDGEMENT_INFO_FIELDS.COMMENTARY]}
                error={judgementInfo.commentary === '' && !isInputChanged}
                helperText={
                  judgementInfo.commentary === '' && !isInputChanged
                    ? requiredFieldMessage
                    : ''
                }
              />
            </div>
            <div className="judgement-on-merits-info-conclusion">
              <FormControlLabel
                control={
                  <Checkbox
                    name={JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION}
                    checked={defenseToExecution}
                    onChange={handleCheckBoxChangeDefenseToExecution}
                    color="primary"
                  />
                }
                label={translate(
                  messages.judgementOnMeritsDefenseToExecutionFieldTitle,
                  props,
                )}
              />
            </div>
            <div className="judgement-on-merits-info-conclusion">
              <FormControlLabel
                control={
                  <Checkbox
                    name={JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION}
                    checked={difficultyToExecution}
                    onChange={handleCheckBoxChangeDifficultyToExecution}
                    color="primary"
                  />
                }
                label={translate(
                  messages.judgementOnMeritsDifficultyToExecutionFieldTitle,
                  props,
                )}
              />
            </div>
          </div>
          <div className="judgement-on-merits-doc-info">
            <UploadDocumentBloc
              index={0}
              document={JudgementOnMeritsDoc}
              setDocument={setDocument}
              resetUploadedDocument={resetUploadedDocument}
              uploadDocument={uploadDocument}
              uploadedDocument={uploadedDocument}
              docType={DOCUMENT_TYPES.APPEAL_ON_MERITS}
              setDocumentId={setDocumentId}
              docId={CORRECTIONAL_DOC_ID}
            />
            <Grid item xs={3} style={{ marginTop: '20px' }}>
              {!isEmpty(props.imagineDocuments) &&
                featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) &&
                props.isManager && (
                  <ImportImagineDocumentButton
                    listings={props.listings}
                    managerNotifcationsInboxes={props.imagineDocuments}
                    claimId={claimId}
                    imagineDocuments={props.imagineDocuments}
                    claimSagisInfo={resolveSagisClaim(props.policyInfo)}
                    uploadDocument={uploadDocument}
                    uploadedDocument={uploadedDocument}
                    setUploadedDocs={setDocument}
                    documentName={
                      DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                    }
                    documentType={
                      DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                    }
                    setDocumentId={setDocumentId}
                    documentId={CORRECTIONAL_DOC_ID}
                    requestGetDocByDocumentumId={
                      props.requestGetDocByDocumentumId
                    }
                  />
                )}
            </Grid>
          </div>
        </>
      ) : (
        <>
          <div className="correctional-judgement">
            <TextField
              id="depens"
              name={JUDGEMENT_INFO_FIELDS.DEPENS}
              label={translate(
                messages.judgementOnMeritsDepensFieldTitle,
                props,
              )}
              InputProps={{
                value: get(
                  judgementOnMerits['judgementOnMerits']['jom'],
                  'responsibility',
                  '',
                ),
                readOnly: true,
              }}
            />
            {get(judgementOnMerits['judgementOnMerits']['jom'], 'cost', '') && (
              <div className="judgement-on-merits-info">
                <TextField
                  id="cost"
                  name={JUDGEMENT_INFO_FIELDS.COST}
                  label={translate(
                    messages.judgementOnMeritsCostFieldTitle,
                    props,
                  )}
                  InputProps={{
                    value: get(
                      judgementOnMerits['judgementOnMerits']['jom'],
                      'cost',
                      '',
                    ),
                    readOnly: true,
                  }}
                />
              </div>
            )}
            <div className="judgement-on-merits-info">
              <TextField
                id="idd"
                name={JUDGEMENT_INFO_FIELDS.IDD}
                label={translate(
                  messages.judgementOnMeritsIddFieldTitle,
                  props,
                )}
                InputProps={{
                  value: get(
                    judgementOnMerits['judgementOnMerits']['jom'],
                    'idd',
                    '',
                  ),
                  readOnly: true,
                }}
              />
            </div>
            {get(
              judgementOnMerits['judgementOnMerits']['jom'],
              'calculationStartDate',
              '',
            ) && (
              <div className="judgement-on-merits-info">
                <TextField
                  id="calculation_date_field"
                  label={translate(messages.judgementInfoDate, props)}
                  value={get(
                    judgementOnMerits['judgementOnMerits']['jom'],
                    'calculationStartDate',
                    '',
                  ).substring(0, 10)}
                  InputProps={{ readOnly: true }}
                />
              </div>
            )}
            {get(
              judgementOnMerits['judgementOnMerits']['jom'],
              'commentary',
              '',
            ) && (
              <div className="judgement-on-merits-info">
                <TextField
                  id="commentary_field"
                  label={translate(
                    messages.judgementOnMeritsCommentaryFieldTitle,
                    props,
                  )}
                  value={get(
                    judgementOnMerits['judgementOnMerits']['jom'],
                    'commentary',
                    '',
                  )}
                  InputProps={{ readOnly: true }}
                />
              </div>
            )}
          </div>
          {get(
            judgementOnMerits['judgementOnMerits']['jom'],
            'defenseToExecution',
            false,
          ) && (
            <div className="judgement-on-merits-info">
              <FormControlLabel
                control={
                  <Checkbox
                    name={JUDGEMENT_INFO_FIELDS.DEFENSE_TO_EXECUTION}
                    checked={get(
                      judgementOnMerits['judgementOnMerits']['jom'],
                      'defenseToExecution',
                      '',
                    )}
                    color="primary"
                  />
                }
                label={translate(
                  messages.judgementOnMeritsDefenseToExecutionFieldTitle,
                  props,
                )}
                disabled={true}
              />
            </div>
          )}
          {get(
            judgementOnMerits['judgementOnMerits']['jom'],
            'difficultyToExecution',
            '',
          ) && (
            <div className="judgement-on-merits-info">
              <FormControlLabel
                control={
                  <Checkbox
                    name={JUDGEMENT_INFO_FIELDS.DIFFICULTY_TO_EXECUTION}
                    checked={get(
                      judgementOnMerits['judgementOnMerits']['jom'],
                      'difficultyToExecution',
                      '',
                    )}
                    color="primary"
                  />
                }
                label={translate(
                  messages.judgementOnMeritsDifficultyToExecutionFieldTitle,
                  props,
                )}
                disabled={true}
              />
            </div>
          )}
          {judgementOnMerits['judgementOnMerits']['jom']['document'] && (
            <div className="judgement-on-merits-doc-info">
              <Document
                name={get(judgementOnMerits['judgementOnMerits']['jom'], [
                  'document',
                  'name',
                ])}
                type={get(judgementOnMerits['judgementOnMerits']['jom'], [
                  'document',
                  'type',
                ])}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      get(judgementOnMerits['judgementOnMerits']['jom'], [
                        'document',
                      ]) as any,
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
            </div>
          )}
          {featureService.hasFeature(FEATURES.ADD_SUPPORT_DOCUMENTS) &&
            props.isAssignedLawyer &&
            isEmpty(judgementOnMeritsSupportDocuments) && (
              <section className="add-recap-bloc">
                {resetUploadedDocument && uploadDocument && uploadedDocument && (
                  <>
                    <div className="add-recap-bloc-title">
                      {translate(messages.supportDocument, props)}
                    </div>
                    <Grid container direction="row" spacing={2}>
                      <Grid item xs={4}>
                        <UploadDocumentBloc
                          index={1}
                          document={supportDocument}
                          setDocument={setJudgementOnMeritsSupportDocument}
                          resetUploadedDocument={resetUploadedDocument}
                          uploadDocument={uploadDocument}
                          uploadedDocument={uploadedDocument}
                          docType={
                            DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                          }
                          setDocumentId={setDocumentId}
                          docId={SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID}
                        />
                      </Grid>
                      <Grid item xs={3} style={{ marginTop: '20px' }}>
                        {!isEmpty(props.imagineDocuments) &&
                          props.isManager &&
                          featureService.hasFeature(
                            FEATURES.TRAITEMENT_IMAGINE_DOC,
                          ) && (
                            <ImportImagineDocumentButton
                              listings={props.listings}
                              managerNotifcationsInboxes={
                                props.imagineDocuments
                              }
                              claimId={claimId}
                              imagineDocuments={props.imagineDocuments}
                              claimSagisInfo={resolveSagisClaim(
                                props.policyInfo,
                              )}
                              uploadDocument={uploadDocument}
                              uploadedDocument={uploadedDocument}
                              setUploadedDocs={
                                setJudgementOnMeritsSupportDocument
                              }
                              documentName={
                                DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                              }
                              documentType={
                                DOCUMENT_TYPES.SUPPORT_DOCUMENT_APPEAL_ON_MERITS
                              }
                              documentId={SUPPORT_DOC_JUDGEMENT_ON_MERITS_ID}
                              setDocumentId={setDocumentId}
                              requestGetDocByDocumentumId={
                                props.requestGetDocByDocumentumId
                              }
                            />
                          )}
                      </Grid>
                    </Grid>
                  </>
                )}
              </section>
            )}
          {!isEmpty(judgementOnMeritsSupportDocuments) && (
            <div className="judgement-on-merits-doc-info">
              <Document
                name={get(judgementOnMeritsSupportDocuments[0], 'name', '')}
                type={get(judgementOnMeritsSupportDocuments[0], 'type', '')}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      judgementOnMeritsSupportDocuments[0] as any,
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default injectIntl(AdditionalInfoJudgementOnMerits);
